import { Grid, Paper, Table, TableBody, Typography, TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import ChartGrasa from './chartGrasa';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import { GraficasStyles } from '../GraficasStyles';

const CardGrasa = ({ rows, isLoad, paperStyle, lIcgs, genero }) => {
  const classes = GraficasStyles();
  const Genero = genero ? genero : "";

  return (
    <Paper>
      <Typography className={classes.title} color='primary'>Porcentaje de Grasa Corporal</Typography>

      <Grid container spacing={2}>
        {/* Columna para la tabla */}
        <Grid item xs={12} lg={6}>
          <Paper className={paperStyle}>
            <Table size="small">
              <TableHead>
                <TableRow alignItems="center">
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Igc</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoad ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">Cargando...</TableCell>
                  </TableRow>
                ) : (
                  rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreate)))}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.igc.toFixed(3))}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>

        {/* Columna para ChartGrasa */}
        <Grid item xs={12} lg={6}>
          <Paper className={paperStyle}>
            <ChartGrasa data={lIcgs} genero={Genero} />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default CardGrasa;
